import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const vimeoEmbed: ComponentTemplate = {
  id: "vimeoEmbed",
  storeId: null,
  scope: "left-bar",
  type: "component",

  name: "Video/Vimeo",
  leftBarCategory: { main: "media", subCategory: "video" },
  preview: "video/vimeo-embed.svg",
  tags: ["embed", "video"],
  template: {
    id: "7675e384-f51b-40a2-a5b1-908918bc9bce",
    type: "vimeoEmbedV2",
    props: {},
  },
};
